import { useState } from "react";
import AppShell from "@/components/AppShell";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Building2, Receipt, Timer, BarChart3 } from "lucide-react";
import { ApOverviewTab } from "@/components/payables/ApOverviewTab";
import { VendorsTab } from "@/components/payables/VendorsTab";
import { BillsTab } from "@/components/payables/BillsTab";
import { AgingTab } from "@/components/payables/AgingTab";

export default function Payables() {
  const [tab, setTab] = useState("overview");
  return (
    <AppShell>
      <div className="mb-8">
        <div className="text-xs tracking-[0.2em] uppercase text-[var(--muted-text)]">Money out</div>
        <h1 className="font-display text-4xl mt-2">Payables</h1>
        <p className="text-sm text-[var(--muted-text)] mt-1 max-w-xl">
          Vendors, bills you owe, and how long you've had them on the shelf.
        </p>
      </div>
      <Tabs value={tab} onValueChange={setTab} className="space-y-6">
        <TabsList className="bg-[var(--hover)]">
          <TabsTrigger value="overview" data-testid="tab-ap-overview"><BarChart3 className="w-4 h-4 mr-2" /> Overview</TabsTrigger>
          <TabsTrigger value="bills" data-testid="tab-bills"><Receipt className="w-4 h-4 mr-2" /> Bills</TabsTrigger>
          <TabsTrigger value="vendors" data-testid="tab-vendors"><Building2 className="w-4 h-4 mr-2" /> Vendors</TabsTrigger>
          <TabsTrigger value="aging" data-testid="tab-aged-ap"><Timer className="w-4 h-4 mr-2" /> Aged AP</TabsTrigger>
        </TabsList>
        <TabsContent value="overview"><ApOverviewTab onOpen={setTab} /></TabsContent>
        <TabsContent value="bills"><BillsTab /></TabsContent>
        <TabsContent value="vendors"><VendorsTab /></TabsContent>
        <TabsContent value="aging"><AgingTab /></TabsContent>
      </Tabs>
    </AppShell>
  );
}
